<template>
    <div class="profile-image">
        <div class="image-container">
            <img :src="profileImageSource" :class="{default: !user.profile_image}" @error="refreshUserImage"/>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Mixins from '../../mixins/mixins';

    export default {
        mixins: [Mixins],
        computed: {
            ...mapGetters({
                user: "auth/getUser"
            }),
            profileImageSource() {
                return this.user.profile_image || this.imageUrl('anonymous.svg');
            },
        },
        methods: {
            refreshUserImage() {
                this.$store.dispatch('auth/refreshUser');
            }
        }
    }
</script>
